// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__a3oQt","buttons":"styles_buttons__3Efy7"};